import { Badge, BadgeProps } from "@/components/Base/Badge";
import { XIcon } from "lucide-react";
import { MouseEventHandler, ReactNode } from "react";
import { cn } from "@/lib/utils";

type TagProps = BadgeProps & {
  label: string;
  icon?: ReactNode;
  onXClick?: () => void;
};

export const Tag = ({
  label,
  icon,
  onXClick,
  className,
  variant = "outline",
  type = "tight",
  ...props
}: TagProps) => {
  const handleXClick: MouseEventHandler = (e) => {
    e.stopPropagation();
    if (onXClick) {
      onXClick();
    }
  };
  return (
    <Badge
      variant={variant}
      type={type}
      className={cn(
        "flex items-center gap-1 text-[10px] uppercase leading-none",
        className
      )}
      {...props}
    >
      {icon}
      {icon ? (
        // When icon is present, wrap label in its own element so it becomes independently
        // queryable by screen.getByText(). Since Badge renders a plain <div>, without this
        // wrapper, getByText would match the Badge div itself (not a node adjacent to icon).
        <span>{label}</span>
      ) : (
        label
      )}
      {onXClick ? (
        <button
          onClick={handleXClick}
          className="rounded-sm p-0.5 hover:scale-110 hover:bg-destructive hover:text-destructive-foreground"
        >
          <XIcon size={12} />
        </button>
      ) : null}
    </Badge>
  );
};
